import { Component, Input } from '@angular/core';

/**
 * Renders the azimuth and down tilt rows shared by the cuboid and rect-tube
 * property panels.
 */
@Component({
  selector: 'app-layer-details-orientation',
  templateUrl: './layer-details-orientation.component.html',
})
export class LayerDetailsOrientationComponent {
  @Input() azimuth?: number;
  @Input() verticalTilt?: number;
}
